import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  List,
  TextField,
  ListItemIcon,
  ListItemText,
  Typography
} from '@mui/material';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import ListItem from '@mui/material/ListItem';
import Toolbar from '@mui/material/Toolbar';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import { getUserRole, getTokenWs } from 'src/utils/Common';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

export const NAVBAR_WIDTH = 300; // Layout (içerik paddingLeft) ve TopBar (marginLeft) ile aynı

const useStyles = makeStyles(() => ({
  navButton: {
    color: '#263238',
    textAlign: 'left',
    textTransform: 'none',
    width: '100%',
    padding: '8px 12px',
    borderRadius: '10px',
    margin: '1px 8px',
    transition: 'background-color 0.15s, color 0.15s',
    fontWeight: 500,
    fontSize: '0.9rem',
    '& $navIcon': { color: '#455a64' },
    '&:hover': {
      backgroundColor: '#fff8e1',
      color: '#212121',
      '& $navIcon': { color: '#FF9800' }
    }
  },
  navSection: {
    fontSize: '0.7rem',
    color: '#ef6c00',
    fontWeight: 700,
    letterSpacing: '1px',
    textTransform: 'uppercase',
    marginTop: '8px',
    marginBottom: '2px'
  },
  navIcon: {
    color: 'inherit',
    minWidth: '36px',
    '& .MuiSvgIcon-root': { fontSize: '20px' }
  },
  // Seçili menü: açık turuncu zemin + sol turuncu şerit
  navButtonActive: {
    position: 'relative',
    backgroundColor: '#fff3e0',
    borderRadius: '10px',
    color: '#e65100',
    textAlign: 'left',
    textTransform: 'none',
    width: '100%',
    padding: '8px 12px',
    margin: '1px 8px',
    fontWeight: 600,
    fontSize: '0.9rem',
    '& $navIcon': { color: '#FF9800' },
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: '8px',
      bottom: '8px',
      width: '3px',
      borderRadius: '0 3px 3px 0',
      backgroundColor: '#FF9800'
    },
    '&:hover': {
      backgroundColor: '#ffe0b2'
    }
  },
  chatButton: {
    textTransform: 'none',
    color: '#263238',
    justifyContent: 'flex-start',
    borderRadius: '10px',
    width: '100%',
    padding: '8px 12px',
    margin: '1px 8px',
    fontSize: '0.9rem',
    fontWeight: 500,
    transition: 'background-color 0.15s',
    '& .MuiButton-startIcon': { color: '#455a64', marginRight: 0, minWidth: '36px' },
    '&:hover': {
      backgroundColor: '#fff8e1',
      '& .MuiButton-startIcon': { color: '#FF9800' }
    }
  },
  search: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px',
      backgroundColor: '#f5f5f5',
      fontSize: '13px',
      '& fieldset': { borderColor: 'transparent' },
      '&:hover fieldset': { borderColor: '#e0e0e0' },
      '&.Mui-focused fieldset': { borderColor: '#FF9800', borderWidth: '1px' }
    }
  }
}));

function NavBar({ open, Menu, onClose, onOpenNavBar, changeTopBarRotation }) {
  const classes = useStyles();
  const tokenWs = getTokenWs();
  const userRole = getUserRole().Menu;
  const Role = getUserRole().RoleId;

  const [MenuShow, setMenuShow] = React.useState(true);
  const [menuSearch, setMenuSearch] = React.useState('');
  const menuQuery = menuSearch.trim().toLocaleLowerCase('tr-TR');
  const isAuthorizedMenu = (item) => userRole?.filter((i) => i.MENU_NAME == item.title).length > 0;
  const matchesSearch = (item) => !menuQuery || item.title.toLocaleLowerCase('tr-TR').includes(menuQuery);

  // Menü kullanım sayacını yönet
  const getMenuClickCount = (menuTitle) => {
    const counts = JSON.parse(localStorage.getItem('menuClickCounts') || '{}');
    return counts[menuTitle] || 0;
  };

  const incrementMenuClickCount = (menuTitle) => {
    const counts = JSON.parse(localStorage.getItem('menuClickCounts') || '{}');
    counts[menuTitle] = (counts[menuTitle] || 0) + 1;
    localStorage.setItem('menuClickCounts', JSON.stringify(counts));
  };

  const sortMenuItemsByUsage = (items) => {
    return [...items].sort((a, b) => {
      const countA = getMenuClickCount(a.title);
      const countB = getMenuClickCount(b.title);
      return countB - countA; // En çok kullanılan üstte
    });
  };

  function ekutuphane() {
    var deger;
    deger = '&SessionToken=' + tokenWs;
    var targetPage =
      'https://servis.arcelik.com.tr/arek/aspx/frmEkutuphane.aspx?' + deger;
    var width = 1150;
    var height = 500;
    var left = parseInt(window.screen.availWidth / 2 - width / 2);
    var top = parseInt(window.screen.availHeight / 2 - height / 2);
    var windowFeatures =
      'width=' +
      width +
      ',height=' +
      height +
      ',status,resizable,left=' +
      left +
      ',top=' +
      top +
      'screenX=' +
      left +
      ',screenY=' +
      top;
    window.open(targetPage, 'subWind', windowFeatures);
  }

  const setMenuShowFnc = (menuTitle) => {
    // Menü kullanım sayacını artır
    if (menuTitle) {
      incrementMenuClickCount(menuTitle);
    }

    if (MenuShow) {
      setMenuShow(false);
    } else {
      setMenuShow(true);
    }

    changeTopBarRotation();
    onOpenNavBar();
  };

  function degYorumlarGoster() {
    // var deger;
    // deger = "&bn=" + bn;
    // deger += "&bk=" + bk;
    var targetPage =
      'microsoft-edge:http://mhnet/THPortal/YORUM/aspx/Main.aspx';
    var width = 1150;
    var height = 500;
    var left = parseInt(window.screen.availWidth / 2 - width / 2);
    var top = parseInt(window.screen.availHeight / 2 - height / 2);
    var windowFeatures =
      'width=' +
      width +
      ',height=' +
      height +
      ',status,resizable,left=' +
      left +
      ',top=' +
      top +
      'screenX=' +
      left +
      ',screenY=' +
      top;
    const newWindow = window.open(targetPage, 'subWind', windowFeatures); // Chrome veya diğer tarayıcılar üzerinden açılan sayfanın kapanmasını sağlamak için
    if (newWindow) {
      setTimeout(() => {
        newWindow.close();
      }, 15000); // 1 saniye bekleyip kapatmaya çalışır
    }
  }

  return (
    <>
      <Drawer
        sx={{
          width: NAVBAR_WIDTH,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: NAVBAR_WIDTH,
            boxSizing: 'border-box',
            backgroundColor: '#fff',
            borderRight: '1px solid #e0e0e0',
            overflowX: 'hidden',
            display: 'flex',
            flexDirection: 'column'
          }
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        {/* Üst bar (TopBar) menünün üstünde durduğu için onun yüksekliği kadar boşluk */}
        <Toolbar sx={{ flexShrink: 0 }} />
        <Box sx={{ p: '12px 12px 4px', flexShrink: 0 }}>
          <TextField
            size="small"
            fullWidth
            placeholder="Menüde ara…"
            value={menuSearch}
            onChange={(e) => setMenuSearch(e.target.value)}
            className={classes.search}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: 18, color: '#90a4ae' }} />
                </InputAdornment>
              ),
              endAdornment: menuSearch ? (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setMenuSearch('')}>
                    <CloseIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </InputAdornment>
              ) : null
            }}
          />
        </Box>
        <List
          sx={{
            padding: '4px 4px 12px',
            overflowY: 'auto',
            overflowX: 'hidden',
            flex: 1,
            minHeight: 0,
            '&::-webkit-scrollbar': {
              width: '8px'
            },
            '&::-webkit-scrollbar-track': {
              background: 'rgba(0, 0, 0, 0.03)',
              borderRadius: '10px',
              margin: '8px'
            },
            '&::-webkit-scrollbar-thumb': {
              background: '#cfd8dc',
              borderRadius: '10px',
              '&:hover': {
                background: '#b0bec5'
              }
            }
          }}
        >
          {Menu.map((section, index) => {
            const visibleItems = sortMenuItemsByUsage(section.items).filter(
              (item) => isAuthorizedMenu(item) && matchesSearch(item)
            );
            if (visibleItems.length === 0) return null;
            return (
            <div key={'section' + index}>
              <ListItem
                sx={{
                  paddingLeft: '16px',
                  paddingTop: index === 0 ? '4px' : '12px'
                }}
              >
                <Typography
                  component="h5"
                  gutterBottom
                  variant="h6"
                  className={classes.navSection}
                >
                  {section.title}
                </Typography>
              </ListItem>
              {visibleItems.map(
                (item, itemIndex) => (
                    <ListItem key={'nav' + itemIndex} sx={{ padding: '2px 0' }}>
                      <Button
                        component={RouterLink}
                        to={item.href}
                        className={
                          window.location.pathname === item.href
                            ? classes.navButtonActive
                            : classes.navButton
                        }
                        onClick={() => setMenuShowFnc(item.title)}
                      >
                        <ListItemIcon className={classes.navIcon}>
                          {item.icon}
                        </ListItemIcon>
                        <ListItemText
                          primary={item.title}
                          primaryTypographyProps={{
                            style: {
                              fontSize: '0.9rem',
                              fontWeight:
                                window.location.pathname === item.href
                                  ? 600
                                  : 500
                            }
                          }}
                        />
                      </Button>
                    </ListItem>
                  )
              )}
            </div>
            );
          })}
          {menuQuery && !Menu.some((section) => section.items.some((item) => isAuthorizedMenu(item) && matchesSearch(item))) && (
            <Box sx={{ p: 2, textAlign: 'center', fontSize: '12px', color: '#90a4ae' }}>Menü bulunamadı.</Box>
          )}
        </List>
        {Role?.filter((i) => i.ROLE_ID !== 11).length > 0 ? (
          <Box sx={{ flexShrink: 0, pb: 1 }}>
            <Divider
              sx={{ margin: '4px 16px 8px', borderColor: '#eceff1' }}
            />
            <ListItem sx={{ padding: '2px 0' }}>
              <Button
                className={classes.chatButton}
                onClick={() => ekutuphane()}
                startIcon={<LocalLibraryIcon className={classes.navIcon} />}
              >
                {'E-Kütüphane'}
              </Button>
            </ListItem>
            <ListItem sx={{ padding: '2px 0' }}>
              <Button
                className={classes.chatButton}
                onClick={() => {
                  degYorumlarGoster();
                }}
                startIcon={<QuestionAnswerIcon className={classes.navIcon} />}
              >
                {'Yorumlar'}
              </Button>
            </ListItem>
          </Box>
        ) : null}
      </Drawer>
    </>
  );
}

NavBar.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool
};

export default NavBar;
